import compileSymbols from '~/utils/compileSymbols';

var types = ['SET_RESTING_STATE'];

export default compileSymbols(types, 'welcome');
